import useAutoFocus from '@hooks/useAutoFocus';
import Button from '@mui/material/Button';
import IconFullArrowRight from '@ui/icons/imaterial/arrows/Full Arrow Right.svg';
import React, { useRef, useState } from 'react';

import useStyles from './FancyInput.style';

interface FancyInputDoubleProps {
  className?: string;
  onSubmit: (e) => void;
  style?: React.CSSProperties;
  input1Props: React.InputHTMLAttributes<HTMLInputElement>,
  input2Props: React.InputHTMLAttributes<HTMLInputElement>,
  autoFocus?: boolean;
  children?: React.ReactNode;
}

const FancyInputDouble: React.FunctionComponent<FancyInputDoubleProps> = (props) => {
  const { onSubmit, style, children, input1Props, input2Props } = props;
  const { classes } = useStyles({});
  const [value1, setValue1] = useState(input1Props.defaultValue);
  const [value2, setValue2] = useState(input2Props.defaultValue);

  const inputRef = useRef();

  useAutoFocus(inputRef, props.autoFocus);

  return (
    <form
      className={classes.inputWrapper}
      style={style}
      onSubmit={onSubmit}
    >
      <input
        {...input1Props}
        ref={inputRef}
        style={{ width: '50%', marginLeft: 12, ...(input1Props.style || {}) }}
        className={classes.input}
        defaultValue={undefined}
        value={value1}
        data-test="fancy-input-double-input-1"
        onChange={(e) => setValue1(e.target.value)}
      />

      <input
        {...input2Props}
        style={{ width: '50%', marginLeft: 12, ...(input2Props.style || {}) }}
        className={classes.input}
        value={value2}
        defaultValue={undefined}
        data-test="fancy-input-double-input-2"
        onChange={(e) => setValue2(e.target.value)}
      />

      {children}

      <Button
        data-test="fancy-input-double-submit"
        type="submit"
        className={classes.button}
        disabled={!value1 || !value2}
        aria-label="submit"
        variant="contained"
        color="secondary"
      >
        <IconFullArrowRight className={classes.icon} />
      </Button>
    </form>
  );
};

FancyInputDouble.defaultProps = {
  input1Props: {},
  input2Props: {},
};

export default FancyInputDouble;
